import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@material-ui/core';
import classnames from 'classnames';

import styles from './FormTextField.scss';

function TextField(props) {
  const { className, onChange, variant, ...restProps } = props;

  return (
    <MuiTextField
      {...restProps}
      variant={variant}
      className={classnames(styles.field, className, styles[variant])}
      InputLabelProps={{
        className: styles.label,
      }}
      InputProps={{
        classes: {
          notchedOutline: variant === 'outlined' ? styles.container : undefined,
          input: styles.input,
        },
      }}
      onChange={onChange}
    />
  );
}

TextField.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

TextField.defaultProps = {
  className: null,
  variant: 'outlined',
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/controls/TextField.jsx